/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 12/18/2014
 * Time: 11:06 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    //<editor-fold desc="require-region">
    /*-----------------------------------------------------------------------------------------------*/
    var Marionette = require("marionette");
    var Logger = require("logger");
    var _ = require("underscore");

    //Template
    var template = require("ui/tags-container/templates/tagItem.tmpl");

    var Ellipsis = require("ui.plugins/ellipsis");

    //</editor-fold>

    var TagItemView = Marionette.ItemView.extend({

        //<editor-fold desc="extended definitions">
        /*-----------------------------------------------------------------------------------------------*/
        tagName: "div",
        className: "tag-item-container",
        template: template,
        ui: {
            "tagSeparator": ".tag-separator",
            "tagContent": ".tag-content",
            "tagCloseButton": ".tag-close-button"
        },
        events: {
            "click .tag-close-button": "_onCloseButtonClick"
        },
        //</editor-fold>


        //<editor-fold desc="Marionette-Functions">
        /*-----------------------------------------------------------------------------------------------*/
        initialize: function (options) {
            this._initialize(options);
        },
        onRender: function () {
            this._onRender();
        },
        //</editor-fold>


        //<editor-fold desc="publicFunctions">
        /*-----------------------------------------------------------------------------------------------*/

        //</editor-fold>

        //<editor-fold desc="privateFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        _initialize: function(options) {
            this.logger = Logger.getLogger("TagsContainer");
            this.logger.info("Initializing Tag Item View", "TagItemView:_initialize", {options:options});

            this.model = options.model;
            this.tagMaxWidth = options.tagMaxWidth;
            this.tooltipAlign = options.tooltipAlign;
        },

        _onRender: function() {
            this.logger.info("Rendering Tag Item View", "TagItemView:_onRender");

            this._updateMaxWidth();
            this._updateTootipAlign();

            // Call the ellipsis handler using defer to make sure $el is in the DOM when called
            _.defer(_.bind(this._handleEllipsis, this));
        },

        _handleEllipsis: function() {
            Ellipsis.handleNow(this);
            var subText = this.model.getSubText();
            if (!_.isEmpty(subText)) {
                var tooltip = this.model.getValue() + " - " + subText;
                this.ui.tagContent.attr("title", tooltip);
                // tooltip-text (following line) is a patch for an exception in which the tooltip is kept opened while modification is done
                this.ui.tagContent.attr("tooltip-text", tooltip);
            }
        },

        _updateMaxWidth: function() {
            this.ui.tagContent.css("max-width", this.tagMaxWidth);
        },

        _updateTootipAlign: function() {
            if (!_.isEmpty(this.tooltipAlign)) {
                this.ui.tagContent.attr("tooltip-align", this.tooltipAlign);
            }
        },

        _onCloseButtonClick: function(e) {
            this.logger.info("Tag Close button clicked", "TagItemView:_onCloseButtonClick");
            this.trigger("closeButtonClick");
            e.stopPropagation();
        }
        //</editor-fold>

    });

    return TagItemView;

});
